import { FundFamilySidebar } from "features/fund-family/FundFamilySidebar";
import { Outlet, useMatches } from "react-router-dom";
import { QueryBoundary } from "shared/api/QueryBoundary";
import PageContainer from "shared/components/layout/PageContainer";
import { getRouteHandle } from "shared/navigation/RouteHandle";

const FundFamilyLayout: React.FC = () => {
  const matches = useMatches();
  const showSidebar = matches.some(
    (match) => getRouteHandle(match)?.showSidebar,
  );
  return (
    <PageContainer>
      <FundFamilySidebar showSidebar={showSidebar} />
      <QueryBoundary isPage={true}>
        <Outlet />
      </QueryBoundary>
    </PageContainer>
  );
};

export default FundFamilyLayout;
